import SearchIcon from '@components/icons/search-icon'
import HomeIcon from '@components/icons/home-icon'
import { useStore } from '@contexts/store'
import dynamic from 'next/dynamic'
import { Flex, Hide, Text, VStack } from '@chakra-ui/react'
import { useRouter } from 'next/router'
import { ROUTES } from '@utils/routes'

const CartButton = dynamic(() => import('@components/cart/cart-button'), {
  ssr: false,
})

const AuthBar = dynamic(() => import('@components/ui/auth-bar'), {
  ssr: false,
})
// const MobileMenu = dynamic(
//   () => import('@components/layout/header/mobile-menu'),
// )

const BottomNavigation: React.FC = () => {
  const { openSidebar, toggleMobileSearch } = useStore()
  function handleMobileMenu() {
    return openSidebar()
  }
  const router = useRouter()

  return (
    <>
      <Hide above="lg">
        <Flex
          display={{ base: 'flex', sm: 'flex', lg: 'none' }}
          position="fixed"
          bottom="0"
          className="lg:hidden fixed z-30 -bottom-0.5 flex items-center justify-between shadow-bottomNavigation body-font bg-brand-light w-full px-4 md:px-6 lg:px-8 text-brand-muted pb-0.5"
        >
          <VStack
            as="span"
            pb="1"
            pt="1"
            spacing="4px"
            onClick={() => {
              if (router.pathname === ROUTES.HOME) return
              router.push(ROUTES.HOME)
            }}
          >
            <HomeIcon />
            <Text as="span" fontSize="13px">
              Home
            </Text>
          </VStack>
          <VStack
            pb="1"
            pt="1"
            as="button"
            spacing="4px"
            className="flex items-center justify-center flex-shrink-0 h-auto relative focus:outline-none"
            onClick={toggleMobileSearch}
            aria-label="Search Button"
          >
            <SearchIcon />
            <Text as="span" fontSize="13px">
              Search
            </Text>
          </VStack>

          <VStack as="span" pb="1" pt="1" spacing="4px">
            <CartButton hideLabel={true} iconClassName="text-opacity-100" />
            <Text as="span" fontSize="13px">
              Cart
            </Text>
          </VStack>
          <VStack as="span" pb="1" pt="1" spacing="4px">
            <AuthBar />
          </VStack>
        </Flex>
      </Hide>
    </>
  )
}

export default BottomNavigation
